<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title"><span>Contents</span></p>
<p class="center1"><a href="#/xhtml/part">The Tomorrow File</a></p>
<p class="center1"><span href="#/xhtml/part04" title="Link target outside of Sample">The Passion of Molly T.</span></p>
<p class="center1"><span href="#/xhtml/part05" title="Link target outside of Sample">Capital Crimes</span></p>
<p class="center1"><span href="#/xhtml/author1" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?4b921a96